/**
 * Disables the pop up for Google Chrome
 * This is useful so people don't accidentally install
 * the PWA when they can install the native app.
 */
globalThis.addEventListener?.("beforeinstallprompt", (event) => {
    event.preventDefault()
})